import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import {ViewModule} from 'app/views/view.module';
import {PublishedSiteComponent} from "./published_site/published_site.component";
import {RouterModule} from "@angular/router";
import {WidgetReportComponent} from "./widget/widget.component";
import {BeforePaidComponent} from "./before_paid/before_paid.component";
import {SiteTopComponent} from "./site_top/site_top.component";
import {SiteTopDetailsModalComponent} from "./site_top/site_top_details.component";
import {LoadStatComponent} from "./load_stat/load_stat.component";
import {LoadStatDetailsModalComponent} from "./load_stat/load_stat_details.component";
import {WidgetSearchComponent} from "./widget_search/widget_search.component";
import { MxComponent } from './mx/mx.component';
import {SitesService} from "./sites.service";
import { SiteActionComponent } from './action/action.component';

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		RouterModule,
		ReactiveFormsModule
	],
	
	declarations: [
		PublishedSiteComponent,
		BeforePaidComponent,
		WidgetReportComponent,
		SiteTopComponent,
		SiteTopDetailsModalComponent,
		LoadStatComponent,
		LoadStatDetailsModalComponent,
		WidgetSearchComponent,
		MxComponent,
		SiteActionComponent,
	],

	providers: [
		BeforePaidComponent,
		SitesService
	],
	
	entryComponents: [
		SiteTopDetailsModalComponent,
		LoadStatDetailsModalComponent
	]
})
export class SitesModule {
}
